import React from 'react';

function TermsAndConditions({ onBack }) {
  const handleBack = () => {
    if (typeof onBack === 'function') {
      onBack();
    } else {
      try { window.history.back(); } catch (e) {}
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.headerRow}>
          <button type="button" style={styles.backButton} onClick={handleBack}>Back to Consent</button>
        </div>
        <h1 style={styles.title}>Terms and Conditions</h1>
        <p style={styles.updated}>Last updated: July 2026</p>

        <section style={styles.section}>
          <h2 style={styles.heading}>1. Consent to Data Processing</h2>
          <p style={styles.text}>
            By granting consent through this platform, you authorize us to
            collect, store, and process your personal information (including
            name, email, phone number, date of birth, and address) for the
            purpose of providing access to the requested web application.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>2. Use of Information</h2>
          <p style={styles.text}>
            The information you provide will be used only for identity
            verification, account access, and communication related to the
            application you are consenting to use. We do not sell your data
            to third parties.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>3. Data Retention</h2>
          <p style={styles.text}>
            Your consent record and associated data will be retained for as
            long as necessary to fulfill the purpose for which it was
            collected, or as required by applicable law.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>4. Withdrawing Consent</h2>
          <p style={styles.text}>
            You may withdraw your consent at any time by contacting the
            application administrator. Withdrawal of consent may result in
            loss of access to the associated application.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>5. Security of Information</h2>
          <p style={styles.text}>
            We follow reasonable technical and organizational measures to
            protect your personal data from unauthorized access, alteration,
            disclosure, or destruction.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>6. Changes to These Terms</h2>
          <p style={styles.text}>
            We may update these Terms and Conditions from time to time. Any
            changes will be posted on this page with a revised "Last updated"
            date.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>7. Contact</h2>
          <p style={styles.text}>
            For any questions regarding these terms, please contact our
            support team through the application from which you were
            redirected.
          </p>
        </section>
      </div>

      {/* Privacy Notice section */}
      <div style={{ ...styles.card, marginTop: '20px' }}>
        <h1 style={styles.title}>Privacy Notice</h1>
        <p style={styles.updated}>Last updated: July 2026</p>

        <section style={styles.section}>
          <h2 style={styles.heading}>1. What We Collect</h2>
          <p style={styles.text}>
            When you grant consent, we collect your name, email address,
            phone number, date of birth, and address as submitted through
            this form.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>2. Why We Collect It</h2>
          <p style={styles.text}>
            This information is used solely to verify your identity and
            grant you access to the application you are trying to use.
          </p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>3. Your Rights</h2>
          <p style={styles.text}>
            You have the right to request access to, correction of, or
            deletion of your personal data at any time by contacting the
            application administrator.
          </p>
        </section>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    backgroundColor: '#f5f5f5',
    padding: '40px 20px',
    fontFamily: 'Arial, sans-serif',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  headerRow: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: '10px'
  },
  backButton: {
    backgroundColor: '#007bff',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    padding: '8px 12px',
    cursor: 'pointer',
    fontSize: '13px'
  },
  card: {
    backgroundColor: 'white',
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
    padding: '40px',
    maxWidth: '700px',
    width: '100%'
  },
  title: {
    fontSize: '26px',
    marginBottom: '5px',
    color: '#333'
  },
  updated: {
    fontSize: '13px',
    color: '#888',
    marginBottom: '25px'
  },
  section: {
    marginBottom: '20px'
  },
  heading: {
    fontSize: '16px',
    color: '#222',
    marginBottom: '8px'
  },
  text: {
    fontSize: '14px',
    color: '#555',
    lineHeight: '1.6'
  }
};

export default TermsAndConditions;